import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Initialize analytics
const initializeAnalytics = () => {
  // Google Analytics
  const gtagScript = document.createElement('script')
  gtagScript.async = true
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-SQVXLC26CV'
  document.head.appendChild(gtagScript)

  window.dataLayer = window.dataLayer || []
  function gtag(...args: any[]) {
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', 'G-SQVXLC26CV')

  // Microsoft Clarity
  ;(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y)
  })(window, document, "clarity", "script", "qgpd8enwoi")
}

// Initialize analytics when the app starts
initializeAnalytics()

// Add TypeScript declarations
declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
    clarity: (...args: any[]) => void
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)